import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { ComprasProveedorComponent } from '../compras-proveedor/compras-proveedor.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DetalleCompra } from 'src/app/Models/compra/detallecompra/detalle-compra';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Clase } from 'src/app/Models/clase/clase';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Precio } from 'src/app/Models/precio/precio';

@Component({
  selector: 'app-compras-detcompra',
  templateUrl: './compras-detcompra.component.html',
  styleUrls: ['./compras-detcompra.component.css']
})
export class ComprasArticuloComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('txtdocumento', null) txtfirt: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public isShow: boolean = false;
  public pagina: number = 0;
  public articulos: Articulo[] = [];
  public articulo: Articulo = new Articulo();
  public isEdit: boolean = false;
  public funcion: Function = null;
  public pagart: any;
  public pagprecio:any;
  public total:number=0;
  public search = {top: 99999, clase: 0, subclase: 0, subgrupo: 0, text: '', scale: 'DESC', marca:'',opcion:'nombre',codigo:'',nombre:''};
  public modal="modal-lg";
  public showdelete:boolean = false;
  public zindex:number = 10000;
  public usuario = null;
  public precio:Precio = new Precio();
  public precios:Precio[] = [];
  public cantidad:number =0;
  public clases: Clase[] = [];
  public detfactus:DetalleFactura[] = []; /* detalle de factura temporal */
  constructor(private data: DataService,private auth:AuthService) { }

  ngOnInit() {
  }
  public show(affterfunction: Function = null) {
      this.funcion = affterfunction;
      this.isShow = true;
      this.showTab(1);
      this.showdelete=false;
      this.usuario = this.auth.getCurrentUser();
      console.log(this.usuario);
      
      setTimeout(() => {
          this.btnshow.nativeElement.click();
          this.info.hide();
          
          this.GetClase();
          if(this.search.text != ''){
            this.GetData();
          }
      }, 10);
  }

    GetClase() {
        this.data.GetSimple(this.data.api.clase).subscribe(r => {
            this.clases = r;
        }, e => { console.log(e.error.text); },()=>{});
    }
    changeClase(){
        if(this.search.marca != '0'){
            this.GetData();
        }
    }
    GetData() {
        this.articulos=[];
        this.loading.show("cargando..");
        this.data.Search('Articulos', this.search).subscribe(r => {
            console.log(r);
            
            this.loading.hide();
            if (r.length>0) { this.articulos = r; this.total= this.articulos.length; }
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }
showTab(i) {

  this.pagina = i;
  if(this.pagina == 1){this.modal ='modal-lg';}
  else{this.modal='';}
}
search_keypress(e){

}
close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow=false; }, 1000);
    setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
}
    SelectItem(i){
        this.articulo = i as Articulo;
        this.btnclose.nativeElement.click();
    }

    CalculaStock(precio:Precio):number{
        let b = this.detfactus.find(b=>b.precio.idproduct.idproduct = precio.idproduct.idproduct);
        let a = 0;
        let saldo = (precio.idproduct.atributo == '1' ? precio.idproduct.saldo00002 : precio.idproduct.saldo00001);
        
        if(b == undefined){
            a =((parseFloat(saldo) * parseFloat(precio.idproduct.unidad.equivale)) / parseFloat(precio.unidad.equivale)) - parseFloat(this.cantidad+"");
        } else{
            a = ((parseFloat(saldo) * parseFloat(precio.idproduct.unidad.equivale))  / parseFloat(precio.unidad.equivale)) - (parseFloat(this.cantidad+"") + parseFloat(b.cantidad));
        }
        return a;
    }

    IsStock(_precio:Precio):boolean {
        let stock = this.CalculaStock(_precio);
        if((stock) >= 0)
        {
            if(parseFloat(stock+"") >= (parseFloat(stock+"") / parseFloat(_precio.unidad.equivale))){
                return true;
            } else {return false;}
        } else {return false;}
    }
    IsExists(_precio:Precio):boolean{
        let b = this.detfactus.find(b=>b.precio.idprecio == _precio.idprecio);
        return (b== undefined ? false:true);
    }
    SelectItemPrecio(i){
        if(this.IsStock(i as Precio)){
            if(!this.IsExists(i as Precio)){
                this.precio = i as Precio;
                this.btnclose.nativeElement.click();
            } else {
                this.data.notify("El precio con la unidad : [" + i.unidad.unidad +"], ya está agregada a la lista de compras. ","Precio ya existe",0);
            } 
        } else {
            this.data.notify("Stock de producto agotado para la unidad seleccionada. ","Stock Agotado",0);
        }
    }
}
